import axios from './axios';

import Axios from 'axios';

// raw axios without base url
export const getUserLoginRealm = (data) =>
    Axios.post(`${axios.b2URL}/fmanager2.svc/web/GetUserLoginRealm`, data);
